export const utilWorkerInstance = () =>
	new Worker(new URL('libs/shared/util/src/lib/general/web-worker/util.worker', import.meta.url));
